// src/components/Header/Header.jsx
import React, { useState } from "react";
import styles from "./css/Header.module.css";
import Logo from "./Logo";
import NavMenu from "./NavMenu";
import MobileMenu from "./MobileMenu";

export default function Header() {
    const [isMobileOpen, setIsMobileOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileOpen((prev) => !prev);
    };

    return (
        <header className={styles.header}>
            <div className={styles.container}>
                {/* Logo */}
                <Logo />

                {/* Menu de navegação - desktop */}
                <nav className={styles.navDesktop}>
                    <NavMenu />
                </nav>

                {/* Botão do menu mobile */}
                <button
                    className={styles.mobileToggle}
                    onClick={toggleMobileMenu}
                    aria-label="Abrir menu mobile"
                >
                    <span className={styles.bar}></span>
                    <span className={styles.bar}></span>
                    <span className={styles.bar}></span>
                </button>
            </div>

            {/* Menu mobile */}
            {isMobileOpen && (
                <MobileMenu onClose={() => setIsMobileOpen(false)} />
            )}
        </header>
    );
}
